"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M10.941 7.896l-9.67-6.861A.172.172 0 001.18 1a.198.198 0 00-.098.021.165.165 0 00-.064.054A.106.106 0 001 1.14V14.86c0 .033.008.05.017.063A.197.197 0 001.18 15a.172.172 0 00.092-.034l9.67-6.861a.138.138 0 00.046-.05.118.118 0 000-.107.138.138 0 00-.046-.05zM1.851.22C1.08-.327 0 .21 0 1.14V14.86c0 .93 1.08 1.466 1.85.92l9.67-6.862a1.12 1.12 0 000-1.838L1.85.219z"
}));

exports["default"] = _default;